module.exports = __webpack_public_path__ + "static/media/bmw.6ec58905.png";